// extracted by mini-css-extract-plugin
module.exports = {"uppercase":"Binding_uppercase__13YvZ","button":"Binding_button__1w0vh"};